export { RelatedEvents } from './RelatedEvents';
export type { RelatedEventsProps } from './RelatedEvents';
export type { RelatedEventsData, RelatedEvent, PromotedEvent } from './types';
